import { gql } from "apollo-boost";

export const GET_MONTHLY_CLOSING_BY_ID = gql`
  query getConsultoryMonthlyClosure(
    $where: DailyClosingWhereInput
    $relations: [String]
  ) {
    getConsultoryMonthlyClosure(where: $where, relations: $relations) {
      id
      month
      year
      date
      statusId
      periodStartDate
      periodEndDate
      closeEnabledDate
      pharmacyProvider {
        id
        name
        address
        nif
        sector {
          id
          name
        }
      }
      status {
        id
        name
      }
    }
  }
`;

export const GET_BILLINGS_BY_PERIOD = gql`
  query getConsultoryMonthlyClosedDetail(
    $where: ConsultoryMonthlyClosedDetailWhereInput
  ) {
    getConsultoryMonthlyClosedDetail(where: $where) {
      id
      arsId
      insurerName
      insurerRnc
      ncf
      voucherName
      voucherDueDate
      invoices
      contractedValue
      creditedValue
      availableValue
      coverageValue
      taxableCoverageValue
      feeValue
      totalValue
      saleIds
      firstSaleId
    }
  }
`;

export const GET_BILLING_SERVICES_BY_PERIOD = gql`
  query getConsultoryMonthlyClosedServiceDetail(
    $where: ConsultoryMonthlyClosedServicesWhereInput
  ) {
    getConsultoryMonthlyClosedServiceDetail(where: $where) {
      description
      quantity
      price
      value
    }
  }
`;

export const GET_CONSULTORY_AFFILIATE_REPORT_BY_PERIOD = gql`
  query getConsultoryMonthlyAffiliateReport(
    $where: ConsultoryMonthlyClosedServicesWhereInput
  ) {
    getConsultoryMonthlyAffiliateReport(where: $where) {
      claimDate
      claimNumber
      affiliateName
      claimValue
      claimPayment
    }
  }
`;

export const GET_CONSULTORY_BRANCH_REPORT_BY_PERIOD = gql`
  query getConsultoryMonthlyBranchReport(
    $where: ConsultoryMonthlyClosedServicesWhereInput
  ) {
    getConsultoryMonthlyBranchReport(where: $where) {
      branchName
      claimValue
      claimPayment
    }
  }
`;
